import React from "react";
import { Typography, makeStyles, useTheme, SvgIcon } from "@material-ui/core";
import { InfoRounded } from "@material-ui/icons";
import { Theme } from "../.themes";

interface InfoProps {
  title?: string;
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    color: "#333",
    display: "flex",
    flexDirection: "row",
    "& > *:not(:last-child)": {
      paddingRight: theme.spacing(1),
    },
  },
}));

export const Info: React.FC<InfoProps> = (props: InfoProps) => {
  const theme: Theme = useTheme();
  const css = useStyles(theme);

  if (!props.title) {
    return null;
  }

  return (
    <div className={css.container}>
      {(theme.icons?.infoIcon && <SvgIcon>{theme.icons?.infoIcon}</SvgIcon>) ?? <InfoRounded />}
      <Typography variant='body1'>{props.title}</Typography>
    </div>
  );
};

export default Info;
